/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Events_Pagination_NextInputs */

const es_billing_events_pagination_next = /** @type {(inputs: Billing_Events_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiente`)
};

const en_billing_events_pagination_next = /** @type {(inputs: Billing_Events_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

/**
* | output |
* | --- |
* | "Next" |
*
* @param {Billing_Events_Pagination_NextInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_events_pagination_next = /** @type {((inputs?: Billing_Events_Pagination_NextInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Events_Pagination_NextInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_events_pagination_next(inputs)
	return en_billing_events_pagination_next(inputs)
});
export { billing_events_pagination_next as "billing.events.pagination.next" }